export const serverURL = process.env.serverURL || 'http://localhost:8080'



// WEBPACK FOOTER //
// /opt/build/repo/src/config.js